import React from "react";
import First from "./Mobile/First";
import Second from "./Mobile/Second";

const MobileService = () => {
  return (
    <>
      <First />
      <Second />
    </>
  );
};

export default MobileService;
